import { useEffect, useState } from "react";
import { Input } from "./ui/input";
import { wiredService } from "../services/wired";

interface VariavelWiredSelectProps {
  id?: string;
  value: string;
  onChange: (valor: string) => void;
  idConexao: string;
  ativo: boolean;
  disabled?: boolean;
  placeholder?: string;
}

/** Campo de busca com as variáveis de usuário existentes na conexão; aceita digitação manual. */
export function VariavelWiredSelect({
  id,
  value,
  onChange,
  idConexao,
  ativo,
  disabled,
  placeholder = "Buscar variável",
}: VariavelWiredSelectProps) {
  const [variaveis, setVariaveis] = useState<string[]>([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState("");
  const [aberta, setAberta] = useState(false);

  useEffect(() => {
    if (!ativo || !idConexao) {
      setVariaveis([]);
      return;
    }
    let cancelado = false;
    setCarregando(true);
    setErro("");
    wiredService
      .listarVariaveisConexao(idConexao)
      .then((res) => {
        if (cancelado) return;
        setVariaveis(res.usuario ?? []);
        if (!res.ok) setErro(res.erro ?? "Não foi possível listar as variáveis.");
      })
      .catch(() => {
        if (cancelado) return;
        setVariaveis([]);
        setErro("Não foi possível listar as variáveis.");
      })
      .finally(() => {
        if (!cancelado) setCarregando(false);
      });
    return () => {
      cancelado = true;
    };
  }, [ativo, idConexao]);

  const filtradas = variaveis
    .filter((nome) => nome.toLowerCase().includes(value.trim().toLowerCase()))
    .slice(0, 100);

  return (
    <div className="space-y-1">
      <div className="relative">
        <Input
          id={id}
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
            setAberta(true);
          }}
          onFocus={() => setAberta(true)}
          onBlur={() => setTimeout(() => setAberta(false), 150)}
          placeholder={carregando ? "Carregando variáveis..." : placeholder}
          className="font-mono"
          autoComplete="off"
          disabled={disabled}
        />
        {aberta && filtradas.length > 0 && (
          <ul className="absolute z-50 mt-1 max-h-48 w-full overflow-auto rounded-md border border-border bg-popover text-popover-foreground shadow-md">
            {filtradas.map((nome) => (
              <li
                key={nome}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(nome);
                  setAberta(false);
                }}
                className={`cursor-pointer px-3 py-1.5 font-mono text-sm hover:bg-accent ${
                  nome === value ? "bg-accent" : ""
                }`}
              >
                {nome}
              </li>
            ))}
          </ul>
        )}
      </div>
      {erro ? (
        <p className="text-xs text-muted-foreground">{erro} Digite o nome manualmente.</p>
      ) : value.trim() && variaveis.length > 0 && !variaveis.includes(value.trim()) ? (
        <p className="text-xs text-amber-600">Esta variável não existe na conexão selecionada.</p>
      ) : null}
    </div>
  );
}
